// import React, { Component } from 'react';
// import Chart from 'react-apexcharts';

// class BarChart extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       chartData: [],
//       chartOptions: {},
//     };
//   }

//   componentDidMount() {
//     this.setState({
//       chartData: this.props.chartData,
//       chartOptions: this.props.chartOptions,
//     });
//   }

//   render() {
//     return (
//       <Chart
//         options={this.state.chartOptions}
//         series={this.state.chartData}
//         type="bar"
//         width="100%"
//         height="100%"
//       />
//     );
//   }
// }

// export default BarChart;
import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

const BarChart = ({ chartData, chartOptions }) => {
  const [data, setData] = useState([]);
  const [options, setOptions] = useState({});

  useEffect(() => {
    setData(chartData);
    setOptions(chartOptions);
  }, [chartData, chartOptions]);

  return (
    <Chart
      options={options}
      series={data}
      type="bar"
      width="100%"
      height="100%"
    />
  );
};

export default BarChart;
